function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#636E95",
  d: "M23.823 11.877l-8.995-9.194c-.453-.457-1.192-.46-1.65-.006l-.006.006-8.995 9.205c-.44.444-.684 1.044-.677 1.669v9.776c-.002 1.24.967 2.265 2.205 2.334h16.59c1.238-.069 2.207-1.094 2.205-2.334v-9.776c0-.627-.242-1.23-.677-1.68zM11.667 23.333v-7h4.666v7h-4.666zm10.5 0h-3.5v-8.166c0-.645-.523-1.167-1.167-1.167h-7c-.644 0-1.167.522-1.167 1.167v8.166h-3.5V13.51L14 5.168l8.167 8.389v9.776z"
}));

var SvgHomeOutline = function SvgHomeOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home-outline.b3de44c4.svg";
export { ForwardRef as ReactComponent };